module.exports = global.config = {
    url: 'https://stbackapi.smarttile.co.uk/api'
    // url: 'https://localhost:7263/api'
}
